import {
  IGetUmrahList,
  IUmrahFilterOptionData,
} from "../types/umrah-search-type";

function parsePrice(value: string | number | null | undefined): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const normalized = Number(value.replaceAll(",", ""));
    if (Number.isFinite(normalized)) {
      return normalized;
    }
  }

  return null;
}

function parseNumber(value: string | number | null | undefined): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return null;
}

export function getUmrahDurationBucket(duration: number) {
  if (duration <= 7) {
    return "1-7";
  }

  if (duration <= 14) {
    return "8-14";
  }

  return "15+";
}

export function getUmrahGroupSizeBucket(groupSize: number) {
  if (groupSize <= 2) {
    return "1-2";
  }

  if (groupSize <= 5) {
    return "3-5";
  }

  if (groupSize <= 10) {
    return "6-10";
  }

  return "11+";
}

const durationOrder = ["1-7", "8-14", "15+"];
const groupSizeOrder = ["1-2", "3-5", "6-10", "11+"];

export function extractUmrahFilterData(
  results: IGetUmrahList[],
): IUmrahFilterOptionData {
  const prices = results
    .map((item) => parsePrice(item.adult_price))
    .filter((value): value is number => typeof value === "number");

  const minPrice = prices.length ? Math.min(...prices) : 0;
  const maxPrice = prices.length ? Math.max(...prices) : 0;

  const durations = Array.from(
    new Set(
      results
        .map((item) => getUmrahDurationBucket(Number(item.duration)))
        .filter(Boolean),
    ),
  ).sort((a, b) => durationOrder.indexOf(a) - durationOrder.indexOf(b));

  const groupSizes = Array.from(
    new Set(
      results
        .map((item) => parseNumber(item.group_size))
        .filter((value): value is number => typeof value === "number")
        .map((value) => getUmrahGroupSizeBucket(value)),
    ),
  ).sort((a, b) => groupSizeOrder.indexOf(a) - groupSizeOrder.indexOf(b));

  return {
    minPrice,
    maxPrice,
    durations,
    groupSizes,
  };
}
